<template>
  <div class="d-input-group">
    <div>
      <div
        class="d-input-group-content"
        :class="{'is-mobile': mobile}"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobile: {
      default: false,
      type: Boolean
    }
  }
};
</script>
